import LoadingSpinner from "components/atoms/LoadingSpinner/LoadingSpinner";
import { Paragraph } from "components/atoms/Typography";
import { useBuildingCount } from "queries/Reports/Baseline/useBuildingCount";
import React from "react";
import useCurrentFilterset from "queries/Reports/Baseline/useCurrentFilterset";

type ReportsEmptySetWrapperProps = {
    children: React.ReactNode;
};

function ReportsEmptySetWrapper({ children }: ReportsEmptySetWrapperProps) {
    const { reportedVsPublishedState, selectedFiltersetUid, isLoading: isLoadingFilterset } = useCurrentFilterset();
    const { data, isLoading } = useBuildingCount(selectedFiltersetUid);

    if (isLoading || isLoadingFilterset) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "33%",
                }}
            >
                <LoadingSpinner />
            </div>
        );
    }

    if (data && data.count === 0) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "33%",
                }}
            >
                <Paragraph>
                    {reportedVsPublishedState === "reported" ? (
                        <>No buildings match that filtering criteria.</>
                    ) : (
                        <>
                            There are currently no published plans in My plan. As you choose plans to publish at the
                            building level they will show up in My plan.
                        </>
                    )}
                </Paragraph>
            </div>
        );
    }
    return <div>{children}</div>;
}

export default ReportsEmptySetWrapper;
